import { render, staticRenderFns } from "./RegisterDefault.vue?vue&type=template&id=5ed09675&scoped=true&"
import script from "./RegisterDefault.vue?vue&type=script&lang=js&"
export * from "./RegisterDefault.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDefault.vue?vue&type=style&index=0&id=5ed09675&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed09675",
  null
  
)

export default component.exports